import { ditheringFragmentShader } from "@paper-design/shaders";

// Paper Shaders 0.0.82 (Apache-2.0): keep the ripple and Bayer raster untouched.
// Only foreground pixel color gains a second, spatially bounded accent.
const foreground = "vec3 fgColor = u_colorFront.rgb * u_colorFront.a;";
if (!ditheringFragmentShader.includes(foreground)) throw new Error("Unsupported Paper Dithering shader revision");
export const bannerFragmentShader = ditheringFragmentShader
  .replace("uniform vec4 u_colorFront;", "uniform vec4 u_colorFront;\nuniform vec4 u_colorLilac;")
  .replace(foreground, `
    vec2 bannerUV = gl_FragCoord.xy / u_resolution.xy;
    float violetBand = sin(bannerUV.x * 7.0 + bannerUV.y * 2.0 - u_time * 0.32);
    float lilacMix = smoothstep(-0.65, 0.9, violetBand) * 0.78;
    vec3 fgColor = mix(u_colorFront.rgb, u_colorLilac.rgb, lilacMix) * u_colorFront.a;
  `);
